import gql from "graphql-tag";

const query = gql`
    query generateSynthesis(
      $projectId: Int!
      $range: DateRangeInput!
      $criteriaKeys: [CriteriaKey!]
      $dataCollectorId: Int
      $thematics: [ThematicInput!]
      $keywords: [String!]
      $emotions: [Emotions!]
      $clusters: [Cluster!]
      $thematicAnalyzed: ThematicInput!
    ) {
      generateSynthesis(
        projectId: $projectId
        range: $range
        criteriaKeys: $criteriaKeys
        dataCollectorId: $dataCollectorId
        thematics: $thematics
        keywords: $keywords
        emotions: $emotions
        clusters: $clusters
        thematicAnalyzed: $thematicAnalyzed
      ) {
        name
        children {
          name
          children {
            name
            children {
              name
              children {
                name
                children {
                  name
                  children {
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

export default query;
